import React from "react";
import QRCode from "qrcode.react";
import {
  CCard,
  CCardBody,
  CCardFooter,
  CButton,
  CCardHeader,
  CListGroup,
  CListGroupItem,
} from "@coreui/react";

function Finish({ code, ticket }) {
  console.log({ ticket })
  return (
    <CCard>
      <CCardHeader className="text-center">
        <h4>Reserva exitosa</h4>
      </CCardHeader>
      <CCardBody>
        <p>
          Toma una captura de pantalla de este código QR y preséntalo en la
          iglesia el día y hora del servicio seleccionado.
        </p>
        {ticket && <p>Ticket: {ticket.toUpperCase()}</p>}
        <div style={{ textAlign: "center" }}>
          <QRCode value={code} size={150} />
        </div>
        <p>Ten en cuenta las siguientes recomendaciones: </p>
        <hr />
        <CListGroup accent>
          <CListGroupItem accent="dark">
            Llega con mínimo 15 minutos de anticipación al servicio que
            registraste.
          </CListGroupItem>
          <CListGroupItem accent="dark">
            Usa siempre el tapabocas en nuestras instalaciones. Lleva tu
            desinfectante personal y un recipiente con agua para tu hidratación.
          </CListGroupItem>
          <CListGroupItem accent="dark">
            Sigue las instrucciones de bioseguridad y acomodación de los
            voluntarios.
          </CListGroupItem>
          <CListGroupItem accent="dark">
            La reserva se guardará máximo 15 minutos después de haber iniciado
            el servicio.
          </CListGroupItem>
          <CListGroupItem accent="dark">
            Si presentas sintomas de Covid-19 o tienes contacto con alguien
            diagnosticado, cancela tu reserva. Recuerda que puedes conectarte a
            la transmisión en linea el domingo a las 11:15 AM y el miércoles a
            las 7:30 PM.
          </CListGroupItem>
          <CListGroupItem accent="dark">
            Disfruta estar en casa nuevamente.
          </CListGroupItem>
        </CListGroup>
      </CCardBody>
      <CCardFooter>
        <CButton block color="link">
          <a href="https://elcamino.co">Salir</a>
        </CButton>
      </CCardFooter>
    </CCard>
  );
}

export default Finish;
